import { Form, Input, Select } from "antd";
import { isValidPhoneNumber } from "../utils/common-utils";
import { getDialCode, getDialCodes } from "../utils/countryCodes";

type PropType = {
    label?: string,
    errorMessage?: string,
    placeHolder?: string
    isRequired?: boolean
}

const ContactNumberFormItem = ({ label = "Contact Number",
    errorMessage = "Please enter a valid phone number",
    placeHolder = "Phone number",
    isRequired = true 
}: PropType) => {

    const contactNumberPrefix = (
        <Form.Item name="countryCode" style={{ margin: 0, height: 30 }} initialValue={'AU'}>
            <Select className="contact-number-dial-code" optionLabelProp="title" placeholder="(+61)"
                dropdownMatchSelectWidth={false}
                showSearch
                showArrow={true}
                filterOption={(i: string, o: any) => o?.children.toLowerCase().includes(i.toLowerCase())}>
                {getDialCodes().map(c => <Select.Option
                    key={c.code}
                    title={c.dialCode}
                    value={c.code}>{c.name}
                </Select.Option>)}
            </Select>
        </Form.Item>
    );

    return (
        <Form.Item
            label={label}
            className="contact-number-field"
            name="contactNumber"
            dependencies={["countryCode"]}
            rules={[
                isRequired ? ({ getFieldValue }: any) => ({
                    validator(_: any, value: any) {
                        const countryCode = getFieldValue('countryCode') || 'AU';
                        const contactNumber = getFieldValue('contactNumber');
                        if(contactNumber === undefined || contactNumber === "" || contactNumber.length === 0){
                            return Promise.reject(new Error("Please Enter a phone number"));
                        }
                        if (!countryCode && !value) return Promise.resolve();
                        // Get dial code from country code (e.g., 'AU' -> '+61')
                        const countryDailCode = getDialCode(countryCode);
                        // Normalize phone number: remove all non-digits and leading zeros
                        const normalizedNumber = (value || '')
                            .toString()
                            .replace(/\D+/g, '') // Remove all non-digits
                            .replace(/^0+/, '');  // Remove leading zeros
                        
                        if (countryCode && countryDailCode && normalizedNumber && isValidPhoneNumber(`${countryDailCode}${normalizedNumber}`)) {
                            return Promise.resolve();
                        }
                        return Promise.reject(new Error(errorMessage));
                    },
                }) : {}
            ]}
        >
            <Input addonBefore={contactNumberPrefix} placeholder={placeHolder} />
        </Form.Item>
    )
}

export default ContactNumberFormItem;
